import type { IState } from 'shared/store';

/**
 * @todo: удалить РС в задаче CD-261253
 */
export const selectIsCpcAuctionEnabled = (state: IState): boolean => !!state.rs.isCpcAuctionEnabled;
